import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { MathJaxContext, MathJax } from 'better-react-mathjax';

const config = {
  loader: { load: ['input/asciimath'] },
  asciimath: {
    displaystyle: true,
    delimiters: [
      ['§', '§'],
      ['`', '`'],
    ],
  },
};

export default function BlogPostFormula(blok) {
  const { formula } = blok;

  return (
    <div {...storyblokEditable(blok)}>
      <MathJaxContext config={config}>
        <MathJax>{`${formula}`}</MathJax>
      </MathJaxContext>
    </div>
  );
}
